import { ISchema } from '../../@types'
import { mergeDeep } from '@/helpers/utils'
import simple_premium_1w_3_99_1w_19_99_usd from '@/data/products/subscription/prd_8IsoMm2bBoXo'
import simple_premium_1m_9_99_1m_44_usd from '@/data/products/subscription/prd_sbY0NWq9GMkz'
import simple_premium_3m_19_99_3m_79_usd from '@/data/products/subscription/prd_kvFfWmOs3D4D'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				products: [
					{
						idents: {
							discounted: simple_premium_1w_3_99_1w_19_99_usd.ident,
							fallback: null,
						},
					},
					{
						idents: {
							discounted: simple_premium_1m_9_99_1m_44_usd.ident,
							fallback: null,
						},
						default: true,
					},
					{
						idents: {
							discounted: simple_premium_3m_19_99_3m_79_usd.ident,
							fallback: null,
						},
					},
				],
			},
		},
	)
